
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IBook} from "@/interfaces/book.interface";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({})
export default class CarTypeField extends Vue {

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get carTypes() { return this.storeState.book.books[IBook.BookName.carTypes]; }

  get modelValue() { return this.formModel.carTypeId; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'carTypeId',
      value
    });
  };

  enterForTruck() {
    this.modelValue = 3;
    this.$emit('formItemChange');
    this.$emit('confirmForm');
  }
}
